import { CharComp } from '@/components/CharComp'
import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import '../../SpotTrade/styles/handicap-real-time-transaction-body.scss'
import '../../SpotTrade/styles/handicap-real-time-transaction.scss'
import { Handicap } from './Handicap'
import { RealTimeTransaction } from './RealTimeTransaction'

export const HandicapRealTimeTransaction = defineComponent({
  setup() {
    const { t } = useI18n()

    return () => (
      <div class={'handicap-real-time-transaction'}>
        <div class="tabs">
          <CharComp class="tab active">{t('订单簿')}</CharComp>
        </div>
        <Handicap class={'handicap'} />
        <div class="bottom-container">
          <div class="tabs">
            <CharComp class={classNames('tab active', {})}>{t('最新成交')}</CharComp>
          </div>
          <RealTimeTransaction />
        </div>
      </div>
    )
  },
})
